export const ADD_QC_TASK_TAB_CHANGE = 'ADD_QC_TASK_CHANGE_TAB';
export const ADD_QC_TASK_MODAL_ADD_QC_TO_LEAD_OPEN = 'ADD_QC_TASK_MODAL_ADD_QC_TO_LEAD_OPEN';
export const ADD_QC_TASK_MODAL_ADD_QC_TO_LEAD_CLOSE = 'ADD_QC_TASK_MODAL_ADD_QC_TO_LEAD_CLOSE';
export const ADD_QC_TASK_MODAL_ADD_QC_TO_LEAD_CHANGE_SEARCH_VALUE =
  'ADD_QC_TASK_MODAL_ADD_QC_TO_LEAD_CHANGE_SEARCH_VALUE';
export const ADD_QC_TASK_MODAL_SUGGESTED_LEAD_AUTHOR_NAMES_LOADED =
  'ADD_QC_TASK_MODAL_SUGGESTED_LEAD_AUTHOR_NAMES_LOADED';
export const ADD_QC_TASK_MODAL_RESET_SUGGESTED_LEAD_AUTHOR_NAMES =
  'ADD_QC_TASK_MODAL_RESET_SUGGESTED_LEAD_AUTHOR_NAMES';
